import { appState } from './state';
import { metaGet, metaSet } from '@/storage/repo';

const THEME_LS_KEY = 'btv2.theme';

export async function initTheme() {
  const saved = await metaGet('theme');
  const theme = (saved === 'dark' ? 'dark' : 'light') as 'light' | 'dark';
  appState.set(s => ({ ...s, theme }));
  applyTheme(theme);
  mirrorTheme(theme);
}

export function applyTheme(theme: 'light' | 'dark') {
  if (theme === 'dark') document.documentElement.classList.add('dark');
  else document.documentElement.classList.remove('dark');
}

export async function toggleTheme() {
  const next = appState.get().theme === 'dark' ? 'light' : 'dark';
  appState.set(s => ({ ...s, theme: next }));
  applyTheme(next);
  mirrorTheme(next);
  await metaSet('theme', next);
}

/** Mirror to localStorage so the inline boot script can apply it before the app mounts (no light-flash for dark users). */
function mirrorTheme(theme: 'light' | 'dark') {
  try { localStorage.setItem(THEME_LS_KEY, theme); } catch { /* private mode */ }
}
